import { toast } from 'react-hot-toast';
import type { UploadNotification } from '../types/notifications';

const UPLOAD_TOAST_DEDUPE_MS = 10 * 60 * 1000;
const seenUploadToastKeys = new Map<string, number>();

function rememberUploadToastKey(key: string): boolean {
  const now = Date.now();
  const seenAt = seenUploadToastKeys.get(key);
  if (seenAt != null && now - seenAt < UPLOAD_TOAST_DEDUPE_MS) {
    return false;
  }
  seenUploadToastKeys.set(key, now);
  if (seenUploadToastKeys.size > 200) {
    for (const [k, ts] of seenUploadToastKeys) {
      if (now - ts > UPLOAD_TOAST_DEDUPE_MS) {
        seenUploadToastKeys.delete(k);
      }
    }
  }
  return true;
}

function uploadToastLabel(fileType: string, filename: string): string {
  const labels: Record<string, string> = {
    audio: 'Audio',
    video: 'Video',
    promo: 'Promo image',
    artwork: 'Artwork',
    footages: 'Footage',
  };
  const kind = labels[fileType] || fileType || 'File';
  return filename ? `${kind}: ${filename}` : kind;
}

/** Show one success/error toast per upload_id (shared across all hook instances). */
export function showUploadResultToast(notification: UploadNotification): void {
  const { upload_id, status, file_id, error, filename, file_type } = notification;
  if (!upload_id) return;

  if (status === 'completed' && file_id) {
    const key = `${upload_id}:completed`;
    if (!rememberUploadToastKey(key)) return;
    toast.success(`${uploadToastLabel(file_type, filename)} uploaded`, { id: key });
    return;
  }

  if (status === 'failed') {
    const key = `${upload_id}:failed`;
    if (!rememberUploadToastKey(key)) return;
    toast.error(`${uploadToastLabel(file_type, filename)} failed: ${error || 'Unknown error'}`, { id: key });
  }
}

export function resetUploadToastDedupeForTests(): void {
  seenUploadToastKeys.clear();
}
